module.exports = "<vb-main-navigation></vb-main-navigation>\r\n\r\n<a [routerLink]=\"['lager']\">Lager</a>\r\n\r\n<router-outlet name=\"page-content\"></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/navigation/navigation.component.html
// module id = ./src/app/navigation/navigation.component.html
// module chunks = main